import { gql } from 'react-apollo';

export default gql`
  mutation getDocusignEnvelope($input: DocusignEnvelopeInput!) {
    getDocusignEnvelope(input: $input) {
      url
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/getDocusignEnvelope.js